import { SearchBox } from '@checkmarx/cx-ui';
import classNames from 'classnames';
import React, { Component } from 'react';
import PortalDropdown from '../../../portal/portalDropdown';
import DirectoryUsersListContainer from '../usersList';
import styles from './style.scss';

export default class ImportUserFormContainer extends Component {
  
    render() {

        return (
            <div className={classNames(styles.ldapAddGroupsMainWrapper)}>
                <div className={classNames(styles.ldapAddGroupsBody)}>
                    <div>
                        <PortalDropdown
                            dataCy='ddl-directory'
                            width='335px'
                            hintText={this.props.translations.directory}
                            floatingLabelText={this.props.translations.directory}
                            items={this.props.directories}
                            onChange={this.props.directoriesChange}
                            value={this.props.selectedItem}
                            helpTooltipText={this.props.translations.selectDirectoryUsersTooltip}
                        />
                    </div>
                    <div className={classNames(styles.groupMapSearchboxWrapper)}>
                        <form onSubmit={this.props.search}>
                            <SearchBox 
                                dataCy='search-users'
                                onChange={this.props.onChange}
                                placeHolder={this.props.translations.searchUsersPlaceHolder} 
                                value={this.props.searchValue}
                            />
                        </form>
                    </div>
                </div>
                <div className={classNames(styles.ldapUsersDialogContentWrapper)}>
                    <DirectoryUsersListContainer
                        addTeamMember={this.addTeamMember}
                        importUser={this.props.importUser}
                    />
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/users/directoryUsers/importUserForm/index.jsx